import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=d15cf3ca"
import script from "./menuButton.vue?vue&type=script&lang=js"
export * from "./menuButton.vue?vue&type=script&lang=js"
import style0 from "./menuButton.vue?vue&type=style&index=0&id=d15cf3ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports